import * as quickFiltersDefinitions from './quickFiltersDefinitions'

export default {
  computed: {
    quickFiltersDefinition() {
      let filters = {}
      for (const fileName of Object.keys(quickFiltersDefinitions)) {
        // Multiple Filters per file support
        for (const filterInFile of Object.keys(quickFiltersDefinitions[fileName].computed)) {
          filters[filterInFile] = this[filterInFile]
        }
      }
      return filters
    }
  },
  watch: {
    quickFiltersDefinition: {
      immediate: true,
      deep: true,
      handler() {
        this.setQuickFilters()
      }
    }
  },
  mixins: Object.values(quickFiltersDefinitions),
  mounted() {
    this.setQuickFilters()
    this.$root.$on('reloadQuickFilters', () => this.setQuickFilters())
  },
  methods: {
    setQuickFilters() {
      this.$store.dispatch('setQuickFilters', this.quickFiltersDefinition)
    }
  }
}
